const items = [
  "TSSA Licensed",
  "CECA Member",
  "ASME A17.1 Compliant",
  "AODA Accessibility",
  "24/7 Emergency Response",
  "IUEC Certified Mechanics",
  "Toronto · GTA · Hamilton",
  "Modernization Specialists",
];

export default function Marquee() {
  const loop = [...items, ...items];
  return (
    <div className="border-b border-[#E5E5E5] bg-[#F9F9F9] overflow-hidden">
      <div className="vx-marquee-track flex whitespace-nowrap py-5">
        {loop.map((t, i) => (
          <span
            key={i}
            className="mx-6 sm:mx-8 inline-flex items-center gap-4 sm:gap-6 font-display font-black text-xl sm:text-2xl md:text-3xl tracking-tight text-[#0A0A0A]"
          >
            {t}
            <span className="h-2 w-2 bg-[#FF5E00]" aria-hidden />
          </span>
        ))}
      </div>
    </div>
  );
}
